// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"Section-module__sectionHeader___2-7J7","withBottomPadding":"Section-module__withBottomPadding___OatCB"};